import React from 'react';
import { Navigate } from 'react-router-dom';

import { ContentSkeleton } from 'src/components/ContentSkeleton';
import { Container } from 'src/components/Container';
import { useAdminPermissions } from 'src/hooks/useAdminPermissions';
import { getFirstAccessibleRoute } from 'src/utils/permissions';
import { SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP } from 'src/utils/constants';
import { ROUTE_LOGIN } from 'src/utils/routes';

const AdminIndexRedirect = () => {
  const { permissions, initialized, loading } = useAdminPermissions();

  if (!initialized || loading) {
    return (
      <Container padding="2rem">
        <ContentSkeleton variant="minimal" />
      </Container>
    );
  }

  const route = getFirstAccessibleRoute(permissions, SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP);

  return <Navigate to={route ?? ROUTE_LOGIN} replace />;
};

export default AdminIndexRedirect;
